import { render, staticRenderFns } from "./RegisteredCamsTable.vue?vue&type=template&id=8890b272"
import script from "./RegisteredCamsTable.vue?vue&type=script&lang=js"
export * from "./RegisteredCamsTable.vue?vue&type=script&lang=js"
import style0 from "./RegisteredCamsTable.vue?vue&type=style&index=0&id=8890b272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VImg,VSpacer})
